/**
 * Created by Languagenut on 17/06/2019.
 */


import React  from 'react';
import {Radar} from 'react-chartjs-2';
import Translation from '../../store/internationalization-store.js';
/*{id:'listening' , name:'Écouter'},
{id:'speaking' , name:'Parler'},
{id:'reading' , name:'Lire'},
{id:'writing' , name:'Écrire'},*/




export default class SkillsRadar extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentWillReceiveProps(props){
        this.props  = props;
        this.setState({update:true});
    }

    render(){

        let d = [];
        if(this.props.exam != undefined)
        {
            d.push(
                {
                    label: Translation.get(12042 , 'Exam Skills'),
                    backgroundColor: 'rgba(78,180,207,0.2)',
                    borderColor: 'rgba(78,180,207,1)',
                    pointBackgroundColor: 'rgba(78,180,207,1)',
                    pointBorderColor: '#4eb4cf',
                    pointHoverBackgroundColor: '#4eb4cf',
                    pointHoverBorderColor: 'rgba(78,180,207,1)',
                    data: [this.props.exam.listening, this.props.exam.speaking, this.props.exam.reading, this.props.exam.writing]

                }
            )
        }
        else if(this.props.vocabulary != undefined)
        {
            d.push(
                {
                    label: Translation.get(12233, 'Vocabulary'),
                    backgroundColor: 'rgba(29,24,57,0.2)',
                    borderColor: 'rgba(29,24,57,1)',
                    pointBackgroundColor: 'rgba(29,24,57,1)',
                    pointBorderColor: '#1d1839',
                    pointHoverBackgroundColor: '#1d1839',
                    pointHoverBorderColor: 'rgba(179,181,198,1)',
                    data: [this.props.vocabulary.listening, this.props.vocabulary.speaking, this.props.vocabulary.reading, this.props.vocabulary.writing]
                }
            )
        }

        let data = {
            labels: [Translation.get(117 , 'Listening'), Translation.get(118 , 'Speaking'), Translation.get(119 , 'Reading'), Translation.get(120 , 'Writing')],
            datasets: d
        };


        const options = {
            legend:{
                position:'bottom',
                boxWidth:5,
            },
            responsive: true,
            maintainAspectRatio: false,
            scale: {
                // Hides the scale
                ticks: {
                    suggestedMin: 0,
                    suggestedMax: 100
                }
            }
        };

            return  <div>
                <Radar  height={300} data={data}  options={options} />
            </div>
    }
}